import {
  // -- GET (list)
  GET_GLOBAL_PRODUCTS_SUCCESS,
  GET_GLOBAL_PRODUCTS_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_PRODUCT_SUCCESS,
  CREATE_GLOBAL_PRODUCT_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_PRODUCT_SUCCESS,
  UPDATE_GLOBAL_PRODUCT_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_PRODUCT_SUCCESS,
  DELETE_GLOBAL_PRODUCT_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalProducts = (state = {}, action) => {
  switch (action.type) {
    // -- GET (list)
    case GET_GLOBAL_PRODUCTS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalProducts.GET_GLOBAL_PRODUCTS_FAILURE()')
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_PRODUCTS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalProducts.GET_GLOBAL_PRODUCTS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE
    case CREATE_GLOBAL_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalProducts.CREATE_GLOBAL_PRODUCT_FAILURE()')
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_PRODUCT_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalProducts.CREATE_GLOBAL_PRODUCT_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE
    case UPDATE_GLOBAL_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalProducts.UPDATE_GLOBAL_PRODUCT_FAILURE()')
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_PRODUCT_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalProducts.UPDATE_GLOBAL_PRODUCT_SUCCESS()', {
        state,
        action,
        items: state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)
      })
      return {
        ...state,
        items: state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)
      }
    }

    // -- DELETE
    case DELETE_GLOBAL_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalProducts.DELETE_GLOBAL_PRODUCT_FAILURE()')
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_PRODUCT_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalProducts.DELETE_GLOBAL_PRODUCT_SUCCESS()', {
        state,
        action,
        items
      })
      return {
        ...state,
        items
      }
    }

    default:
      return state
  }
}
